module.exports = __webpack_public_path__ + "img/zhkj.925e0570.png";